/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { MatDialog } from '@angular/material/dialog';
import { MyInjector } from '@src/app/app.module';
import { Schedule } from '@src/app/model/schedule';
import { ScheduleValidation } from '@src/app/model/schedule-delta';
import { ScheduleService } from '@src/app/modules/budget/schedule.service';
import { ScheduleValidationComponent } from '@src/app/modules/budget/schedule-validation/schedule-validation.component';
import { IFormAction, ActionColor } from '@src/app/shared/form/form.component';
import { switchMap } from 'rxjs/operators';

/** Asks the server whether the stored apportionment still matches the current units, and shows
 * what would change if it does not. Nothing is applied - the user saves the schedule to do that.
 */
export class ScheduleValidateAction implements IFormAction {
    name = $localize`Validate Schedule`;
    color: ActionColor = 'primary';
    show = false;
    icon = 'fact_check';
    approvalNeeded = false;
    disabled = false;
    approvalText = '';
    tipText = $localize`Check the apportionment is still in step with the current unit data`;
    schedule: Schedule;

    action() {
        const dialog = MyInjector.instance.get(MatDialog);
        const scheduleSvc = MyInjector.instance.get(ScheduleService);

        return scheduleSvc.validateSchedule(this.schedule.id).pipe(
            switchMap((validation: ScheduleValidation) =>
                dialog.open(ScheduleValidationComponent, { data: validation }).afterClosed())
        );
    }

    setup(schedule: Schedule) {
        this.schedule = schedule;
        this.show = !!schedule?.id;
    }
}
